import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceRequest, ServiceRequestClient } from '../web-api-client';

@Injectable({
  providedIn: 'root'
})
export class AllServiceRequestsService {

  constructor(private serviceRequestClient: ServiceRequestClient) { }

  /**
   * Gets all service requests in the system (not filtered by organization)
   * Now connected to the real backend API endpoint
   */
  getAllServiceRequests(): Observable<ServiceRequest[]> {
    // Call the new backend API endpoint for all service requests
    // Pass null for all filter parameters to get all service requests
    return this.serviceRequestClient.getAllServiceRequests(null, null, null, null);
  }


}
